// extracted by mini-css-extract-plugin
export default {"show-more-btn":"showMore_show-more-btn__Cv6mM","children-desktop":"showMore_children-desktop__Hz6IU"};